import React from 'react';

import Button from 'components/shared/Buttons/Button';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const ErrorList = ({ refetch }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <Icon icon="illustration-empty-income" color="primary-900" isStroke size={200} />
      <Typography variant="h4" color="neutral-700">
        Oops! Something went wrong.
      </Typography>
      <Typography variant="h4" color="neutral-700">
        Please try again.
      </Typography>
      <Button text="Try again" onClick={refetch} />
    </div>
  );
};

export default ErrorList;
